import { ProfileIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <ProfileIndexRouteView/>,
};